export const BATTERY_ONLY_PROPOSAL_KIND = "battery_only";

export type VisionProposalMetaT = {
  id?: string | number | null;
  uuid?: string | null;
  slug?: string | null;
  kind?: string | null;
};

export const isBatteryOnlyVisionProposal = (meta?: VisionProposalMetaT | null): boolean =>
  meta?.kind === BATTERY_ONLY_PROPOSAL_KIND;

export const buildVisionProposalUrl = (meta?: VisionProposalMetaT | null): string | null => {
  const visionUrl = process.env.REACT_APP_VISION_CLIENT_URL;

  if (isBatteryOnlyVisionProposal(meta)) {
    const proposalId = meta?.uuid || meta?.id;
    return proposalId ? `${visionUrl}/battery-proposal/${proposalId}` : null;
  }

  return meta?.slug ? `${visionUrl}/proposal/${meta.slug}` : null;
};

export const buildSolarProposalV2Url = (meta?: VisionProposalMetaT | null): string | null => {
  if (!meta?.id || isBatteryOnlyVisionProposal(meta)) return null;

  return `${process.env.REACT_APP_VISION_CLIENT_URL}/solar-proposal/${meta.id}/setup/product-offering`;
};
